import { useState } from 'react';

type CopyLinkState =
  | { status: 'idle' }
  | { status: 'copied' }
  | { status: 'failed'; url: string };

/**
 * Copies a link to the clipboard. Some in-app browsers refuse clipboard
 * access, so a failure keeps the link in `state` for `PressAndHoldLink` to
 * show. `copy` resolves to whether it worked. Each caller words its own
 * confirmation and fires its own events.
 */
export const useCopyLink = () => {
  const [state, setState] = useState<CopyLinkState>({ status: 'idle' });

  const copy = async (url: string) => {
    try {
      await navigator.clipboard.writeText(url);
      setState({ status: 'copied' });
      return true;
    } catch {
      setState({ status: 'failed', url });
      return false;
    }
  };

  return { state, copy };
};
